import { Component, ViewEncapsulation,Input, HostListener } from '@angular/core';
import { PanelItem } from '../panel-item';
import { PanelConfig } from '../panel.config';

@Component({
  selector: 'side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class SideNavComponent {
  @Input() panelItems: PanelItem[] = [];

  // When user clicks on the panel item the smooth scroll is activated by default, this flag when set to true will block the below window scroll event handling 
  isScrolledByPanel = false;

  // Update the active section
  onPanelItemClicked(item: PanelItem): void {
    this.panelItems.forEach(x => x.isActive = (x.id === item.id));

    // Set this to true so that the side panel active selection doesnt move around while automatic scroll is happening
    this.isScrolledByPanel = true;

    //Timeout to reset the flag so that the scroll event handling is handled for manual scrolling
    setTimeout(() => {
      this.isScrolledByPanel = false;
    }, 800);
  }

  // Handle the window scroll to set the active section on manual scroll
  @HostListener('window:scroll', [])
  onScroll(): void {
    if (this.isScrolledByPanel) return;

    const elements = document.querySelectorAll(`[${PanelConfig.SCROLL_ATTRIBUTE}]`);
    let currentSection = '';

    elements.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const isShortSection = rect.height < window.innerHeight;
      // Make a panel item active when the top of the section is close to the upper portion of viewport
      if ((isShortSection && rect.top >= 0 && rect.top <= 100) || (!isShortSection && rect.top <= 100 && rect.bottom >= window.innerHeight * 0.8) ) {
        currentSection = section.id;
      }
    });

    if (currentSection) {
      this.panelItems.forEach(x => x.isActive = (x.id === currentSection));
    }
  }
}
